var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    width: 1920,
    height: 1080,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Abstract Background-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 160,
    height: 160,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAAXNSR0IArs4c6QAAA+tJREFUeF7t18GJFGEUhdH6I9AQNCNDMAPNQCcDzcDQNAMzKBFmMQy48HLhLvrUsun3Hpz6Ft3n8hAYCpzhbacJXAIUwVRAgFN+xwWogamAAKf8jgtQA1MBAU75HRegBqYCApzyOy5ADUwFBDjld1yAGpgKCHDK77gANTAVEOCU33EBamAqIMApv+MC1MBUQIBTfscFqIGpgACn/I4LUANTAQFO+R0XoAamAgKc8jsuQA1MBQQ45XdcgBqYCghwyu+4ADUwFRDglN9xAWpgKiDAKb/jAtTAVECAU37HBaiBqYAAp/yOC1ADUwEBTvkdF6AGpgICnPI7LkANTAUEOOV3XIAamAoIcMrvuAA1MBUQ4JTfcQFqYCogwCm/4wLUwFRAgFN+xwWogamAAKf8jgtQA1MBAU75HRegBqYCApzyOy5ADUwFBDjld1yAGpgKCHDK77gANTAVEOCU33EBamAqIMApv+MC1MBUQIBTfscFqIGpgACn/I4LUANTAQFO+R0XoAamAgKc8jsuQA1MBQQ45XdcgBqYCggw4L/v++11XV+u6/rwPP7jnPMUrHr4EQEGCdz3/e26rk+vRr+fcz4H6x56RIDB67/v+/d1XW9ejf4857wP1j30iACD1/+PAH+dc94F6x56RIDB67/v++vzb8CX00/nnL+fe/5DQID/gfXyq88RfnzxJ0R8gaUAAzQjPQEB9ixtCgQEGKAZ6QkIsGdpUyAgwADNSE9AgD1LmwIBAQZoRnoCAuxZ2hQICDBAM9ITEGDP0qZAQIABmpGegAB7ljYFAgIM0Iz0BATYs7QpEBBggGakJyDAnqVNgYAAAzQjPQEB9ixtCgQEGKAZ6QkIsGdpUyAgwADNSE9AgD1LmwIBAQZoRnoCAuxZ2hQICDBAM9ITEGDP0qZAQIABmpGegAB7ljYFAgIM0Iz0BATYs7QpEBBggGakJyDAnqVNgYAAAzQjPQEB9ixtCgQEGKAZ6QkIsGdpUyAgwADNSE9AgD1LmwIBAQZoRnoCAuxZ2hQICDBAM9ITEGDP0qZAQIABmpGegAB7ljYFAgIM0Iz0BATYs7QpEBBggGakJyDAnqVNgYAAAzQjPQEB9ixtCgQEGKAZ6QkIsGdpUyAgwADNSE9AgD1LmwIBAQZoRnoCAuxZ2hQICDBAM9ITEGDP0qZAQIABmpGegAB7ljYFAgIM0Iz0BATYs7QpEBBggGakJyDAnqVNgYAAAzQjPQEB9ixtCgQEGKAZ6QkIsGdpUyAgwADNSE9AgD1LmwIBAQZoRnoCAuxZ2hQICDBAM9ITEGDP0qZAQIABmpGegAB7ljYFAgIM0Iz0BP4A3TYeoTdYjscAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1920 0v1080h-1920v-1080z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #212121 } \n\t\t.s1 { fill: #fd7014 } \n\t\t.s2 { fill: #ffffff } \n\t\t.s3 { fill: none;stroke: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1920 0v1080h-1920v-1080z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "<Path>",
    href: "#img1",
    transform: "matrix(1,0,0,1,0,0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m288 919.5c0 62.7-50.8 113.5-113.5 113.5c-62.7 0-113.5-50.8-113.5-113.5c0-62.7 50.8-113.5 113.5-113.5c62.7 0 113.5 50.8 113.5 113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m2077 352.5c0 134.5-109 243.5-243.5 243.5c-134.5 0-243.5-109-243.5-243.5c0-134.5 109-243.5 243.5-243.5c134.5 0 243.5 109 243.5 243.5zm-103 0c0-77.6-62.9-140.5-140.5-140.5c-77.6 0-140.5 62.9-140.5 140.5c0 77.6 62.9 140.5 140.5 140.5c77.6 0 140.5-62.9 140.5-140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1920 728.5v107.2c-32.1 0.1-63.8 1.7-92.4 15.5c-61.9 30.2-88.5 108.6-150.1 139.5c-64.1 32.2-151.1 5-205.9 51.3c-12.6 10.6-22 24.1-31 38h-233.5c13.3-25.8 28.7-49.3 38.4-62.8c36.6-50.8 89.6-91.5 150.8-105c71.7-15.7 152.7 5.3 215.8-32.1c54.7-32.4 83.5-102.6 144.1-121.9c39-12.4 82.2-0.1 121.9-10.2c15.3-3.9 29-10.8 41.9-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m530.2 0c-11.3 15.3-21.4 31.5-30.1 47.6c-41.1 76.3-70.7 164-139.6 216.5c-81.6 62.2-197.4 58.6-285 112.1c-29.4 18-54.1 41.3-75.5 67.9v-149.7c26.9-17.8 56.7-32.4 86-44.4c76.6-31.6 160.2-56.5 216.7-117c35.7-38.2 57-87.1 82.4-133z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 983.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 933.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 883.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 833.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 783.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 733.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1845.6 683.1c1.3 0 2.4 1.1 2.4 2.4v7.2h7.2c1.3 0 2.4 1.1 2.4 2.4c0 1.4-1.1 2.4-2.4 2.4h-7.2v7.2c0 1.4-1.1 2.4-2.4 2.4c-1.4 0-2.4-1-2.4-2.4v-7.2h-7.2c-1.4 0-2.4-1-2.4-2.4c0-1.3 1-2.4 2.4-2.4h7.2v-7.2c0-1.3 1-2.4 2.4-2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m826.1-177.4c-45.3-2.7-82.5 41.2-89.3 86c-6.7 44.9 8.8 89.8 23.9 132.6c15.2 42.8 30.4 87.9 23.1 132.7c-12.7 77.9-88.4 129.1-162 157.7c-73.6 28.5-154.7 45.8-214.1 97.9c-50.7 44.5-81.2 111.1-138.8 146.3c-52.4 32-117.3 32.1-178.2 39.6c-61 7.5-127.9 28.6-156.2 83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m668-131c-44.5 12.1-75.3 53.9-89.8 97.6c-14.4 43.7-15.9 90.5-22.4 136.1c-6.6 45.6-19.6 92.7-51.9 125.6c-43.8 44.5-111.9 52.8-166.9 82.5c-48 25.9-85.2 67.6-121.2 108.6c-36.1 41-72.9 83-120.7 109.4c-47.7 26.5-109.2 34.9-156.2 7.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m169.9 30.1c14.4 0.7 29.5 5.9 37.9 17.7c11.3 15.7 7 38-2.3 55.1c-24 44.2-80.1 68.3-128.7 55.1c-9.2-2.4-19.3-7.5-21.2-16.9c-1.3-6.6 2.1-13.2 5.6-19c24.6-42.1 52.1-94.8 108.7-92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m978.3 1203.7c40.6-33.2 58.4-86.8 67.2-138.6c8.9-51.7 10.9-105.1 28.9-154.4c34.3-94 129.6-162.3 229.7-164.5c69.4-1.5 138.4 25.8 207.1 15.5c71.3-10.7 130-59.8 195.2-90.8c166.8-79.3 386.2-24.2 495.8 124.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1128.2 1136.5c-30.2-103.1 22.5-224.1 118.5-272.3c110.1-55.4 250.6-17.9 358.8-76.9c38.5-20.9 69.9-52.7 107.4-75.5c86.9-52.9 205-49.3 288.6 8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1560.9 751.6l-21.3-21.3l99.1-26.6l-26.5 99.2l-21.3-21.3l10.9-41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1472.4 840.1l-21.3-21.3l99.1-26.6l-26.5 99.2l-21.3-21.3l10.9-41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1481.9 1148.9c14.2-47.8 68.9-70.3 118.1-78.5c49.2-8.2 102.8-10.1 142.1-40.7c30.6-23.8 47.5-61.7 77.1-86.8c37.5-32 91.3-39.1 139.8-30.5c48.6 8.7 93.3 31.4 137.2 53.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m684.4-100.3c-53.7 98.3-15.3 228.8-72.9 324.8c-31.5 52.4-86.8 85.7-142.2 111.7c-55.4 26-113.9 47.5-161.8 85.6c-64.6 51.2-108.8 131.4-186.2 159.8c-64.5 23.6-142.1 6.7-199.5 44.4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground05);
export default __webpack_public_path__ + "static/media/Background05.c332bb1b9630f07a63c5f54211104358.svg";
export { ForwardRef as ReactComponent };